import ConfirmButton from '@/features/common/buttons/ConfirmButton'
import Button from '@/features/ui/buttons/components/Button'
import Modal from '@/features/ui/components/Modal'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface CreateShiftCloseoutConfirmationModalProps {
    loading: boolean
    onCancel: () => void
    onConfirm: () => void
}

const CreateShiftCloseoutConfirmationModal: FC<CreateShiftCloseoutConfirmationModalProps> = ({
    loading,
    onCancel,
    onConfirm,
}) => {
    const { t } = useTranslation()

    return (
        <Modal collapsable={false}>
            <View style={styles.content}>
                <Typography.Heading variant="h4" style={styles.description}>
                    {t('shiftCloseouts.create.confirmation')}
                </Typography.Heading>

                <View style={styles.actions}>
                    <ConfirmButton
                        disabled={loading}
                        label={t('actions.yes').toUpperCase()}
                        onConfirm={onConfirm}
                        testID="create-shift-closeout-confirm-button"
                    />
                    <Button
                        color="secondary"
                        disabled={loading}
                        onPress={onCancel}
                        style={styles.cancel}
                        textStyle={styles.cancelText}
                        testID="create-shift-closeout-cancel-button"
                        type="outline"
                    >
                        {t('actions.no').toUpperCase()}
                    </Button>
                </View>
            </View>
        </Modal>
    )
}

const styles = StyleSheet.create({
    content: {
        alignItems: 'center',
        gap: 24,
        paddingHorizontal: 16,
        paddingVertical: 24,
    },
    description: {
        textAlign: 'center',
    },
    actions: {
        alignSelf: 'stretch',
        gap: 12,
    },
    cancel: {
        alignSelf: 'stretch',
        justifyContent: 'center',
    },
    cancelText: {
        textTransform: 'uppercase',
    },
})

export default CreateShiftCloseoutConfirmationModal
